var React = require('react');

function MapMarker (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.5 31.25c2.083 0 12.5-11.846 12.5-18.75S19.404 0 12.5 0 0 5.596 0 12.5s10.417 18.75 12.5 18.75Zm0-12.5a6.25 6.25 0 1 0 0-12.5 6.25 6.25 0 0 0 0 12.5Z","fill":"#ffdb00"}));
}

MapMarker.defaultProps = {"viewBox":"0 0 25 32","fill":"none"};

module.exports = MapMarker;

MapMarker.default = MapMarker;
